import "./loading.css";

export default function Loadingscreen(){
    return(
        <div className="spinner-container">
            <div className="spinner"></div>

        </div>
    );

}